import request from '@/utils/request';
export const defaultAgentsUserData = {
  id: 0,
  enabled: true,
  fullName: '',
  emailAddress: '',
  mobileNumber: '',
  password: undefined,
  agentId: undefined,
  agent: {
    id: null
  },
  roles: [{
    id: 0
  }],
  rolesIds: [],
  assignedDealers: [],
  branches: []
};
export const getAgentsUsers = params => request({
  url: '/agents-users',
  method: 'get',
  params
});
export const getAgentsUserById = id => request({
  url: `/agents-users/${id}`,
  method: 'get'
});
export const updateAgentsUser = (id, data) => request({
  url: `/agents-users/${id}`,
  method: 'patch',
  data
});
export const deleteAgentsUser = id => request({
  url: `/agents-users/${id}`,
  method: 'delete'
});
export const createAgentsUser = data => request({
  url: '/agents-users/',
  method: 'post',
  data
});
export const agentLogin = data => request({
  url: '/agents-users/login',
  method: 'post',
  data
});
export const agentRequestOtp = data => request({
  url: '/agents-users/request-otp',
  method: 'post',
  data
});
export const agentVerifyOtp = data => request({
  url: '/agents-users/verify-otp',
  method: 'post',
  data
});
export const agentLogout = () => request({
  url: '/agents-users/logout',
  method: 'post'
});
export const getAgentInfo = data => request({
  url: '/agents-users/me',
  method: 'post',
  data
});
export const getAgentWiseDealers = params => request({
  url: '/dealers/agent-wise-dealers',
  method: 'get',
  params
});
export const getRoles = params => request({
  url: '/agents-users-roles',
  method: 'get',
  params
});